import { css } from "lit";
import { html } from "lit-html/static.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { updateCSSVariables, getTextClasses, getTag } from "./utils/index.js";
import { tagMap } from "./utils/constants.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfText = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_level = "s";
    this.dsf_color = "neutral";
    this.dsf_inline = false;
    this.dsf_nowrap = false;
  }
  render() {
    updateCSSVariables(this);
    const tag = getTag(this);
    const isInline = tag === tagMap.span;
    const classes = getTextClasses(this, isInline);
    return html`<${tag} class="${classes}" data-skeleton><slot></slot></${tag}>`;
  }
};
DsfText.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: var(--dsf-text-display);
      }
    `
];
DsfText.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfText.prototype, "dsf_level", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfText.prototype, "dsf_color", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfText.prototype, "dsf_color_intensity", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfText.prototype, "dsf_inline", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfText.prototype, "dsf_nowrap", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfText.prototype, "dsf_tag_override", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfText.prototype, "dsf_decoration", 2);
DsfText = __decorateClass([
  defineElement("dsf-text")
], DsfText);
export {
  DsfText
};
